import { MdEventNote as EventNoteIcon } from 'react-icons/md';

export default EventNoteIcon;
